import request from "@/utils/request";

export interface WmsProductSkuList {
	/**
	 * 商品分类id
	 */
	cate_id: number;
	/**
	 * 商品分类名称
	 */
	cate_name: string;
	/**
	 * 创建时间
	 */
	create_at: string;
	/**
	 * 停用原因
	 */
	disable_remark: string;
	/**
	 * skuid
	 */
	id: number;
	/**
	 * 商品sku编码
	 */
	product_code: string;
	/**
	 * 商品sku名称
	 */
	product_name: string;
	/**
	 * 规格描述
	 */
	specs: string;
	/**
	 * 状态：0-停用；1-启用；
	 */
	status: number;
	/**
	 * 实际库存数量
	 */
	stock: number;
	/**
	 * 商品sku图片
	 */
	theme_img: string;
	/**
	 * 更新时间
	 */
	update_at: string;
}

export interface WmsProductListItem {
	/**
	 * 商品分类id
	 */
	cate_id: number;
	/**
	 * 商品分类名称
	 */
	cate_name: string;
	/**
	 * 创建时间
	 */
	create_at: string;
	/**
	 * spuid
	 */
	id: number;
	/**
	 * sku列表集合
	 */
	sku_list: WmsProductSkuList[];
	/**
	 * 商品spu名称
	 */
	spu_name: string;
	/**
	 * 状态：0-停用；1-启用
	 */
	status: number;
	/**
	 * 商品spu图片
	 */
	theme_img: string;
	/**
	 * 总库存
	 */
	total_stock: number;
	/**
	 * 商品spu编码
	 */
	wms_spu_code: string;
}

export type FetchWmsProductListResponse = ListDataResponse<WmsProductListItem>;

export interface FetchWmsProductListRequest extends PaginationParams {
	/**
	 * 库位类型：1-标准货架位 2-地堆位 3-托盘位 4-拣货位 5-暂存位
	 */
	cate_id?: number;
	/**
	 * 产品名称
	 */
	product_name?: string;
	/**
	 * 状态：0-停用 1-启用
	 */
	status?: number;
}

export const fetchWmsProductList = (data: FetchWmsProductListRequest) =>
	request.post<FetchWmsProductListResponse>("/product/getProductList", data);

export interface EnableWmsProductRequest {
	/**
	 * 库位id
	 */
	ids: number[];
	/**
	 * 备注说明
	 */
	remark?: string;
	/**
	 * 是否启用：0-禁用 1-启用
	 */
	status: number;
}

export const enableWmsProduct = (data: EnableWmsProductRequest) =>
	request.post("/product/enabled", data);
